<template>
  <v-card class="boost-strategy pa-6" elevation="1">
    <div class="boost-strategy-title d-flex align-center pb-5">
      <div class="rocket-icon d-flex align-center justify-center">
        <mf-icon icon="rocket_launch" color="marca-1-d30" size="20" />
      </div>
      <div class="d-flex align-center justify-space-between full-width">
        <h2 class="ma-0 ml-3">Estratégia de impulsionamento</h2>
        <!-- <mf-button
          :disabled="(!products || !products.length) && !loading"
          class="unset-capitalize"
          color="marca-0-l40"
          icon="arrow_forward"
          label="Gerar campanha"
          @click="generateCampaign"
        /> -->
      </div>
    </div>
    <mf-loading
      loader="boost-strategy-container"
      loader-type="content"
      title="Carregando dados..."
      :boolean-loader="loading"
      :class="loading && 'boost-strategy-loader'"
    >
      <div v-if="!isEmpty" class="empty-state mt-8">
        <p class="py-2">Selecione os produtos ao lado para visualizar a estratégia de impulsionamento.</p>
      </div>
      <div v-else class="boost-state">
        <div class="boost-state-header d-flex justify-space-between mt-7">
          <div class="boost-state-title d-flex flex-column">
            <h2>Produtos que Impulsionam</h2>
            <span class="pr-3">Produtos que recomendamos serem ofertados como uma forma de aumentar a venda dos produtos em análise.</span>
          </div>
          <div class="d-flex justify-end export-report">
            <export-email-report-dialog
              ref="exportEmailReportDialog"
              title="Relatório da análise"
              description="Esse relatório contém os produtos que estão sendo análisados e os produtos que sugerimos que sejam promocionados como estratégia de impulsionamento. "
              :exportReportFn="exportProductsAnalysis"
              :iconSize="16"
              async
              @file-format="getFileFormat"
            />
          </div>
        </div>
        <v-data-table
          class="mt-7 products-table"
          no-data-text="Nenhum produto encontrado"
          :hide-default-footer="filteredProducts <= 10"
          :headers="headers"
          :items="filteredProducts"
          :footer-props="{
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :options.sync="options"
          :loading="loadingTable"
        >
          <template v-slot:item.product.name="{ item }">
            <div class="ellipsis-container">
              <span class="ellipsis-td link" @click="openProduct(item.product.sku)">
                {{ item.product.name }}
              </span>
            </div>
          </template>

          <template v-slot:item.confidence="{ item }">
            <mf-tooltip max-width="450" top variant="secondary">
              <template v-slot:activator>
                <confidence-tag :confidence="item.confidence" />
              </template>
              <div class="product-tooltip d-flex flex-column px-3 py-3">
                <h2>{{ item.product.name.toUpperCase() }}</h2>
                <div>
                  <span class="tooltip-label pr-2">Confiança:</span>
                  <confidence-tag :confidence="item.confidence" />
                </div>
                <div class="pt-1">
                  <span class="tooltip-text">
                    A presença {{ confidenceDescription[item.confidence] }} desse produto em cupons que também contêm os
                    <confidence-tag variant="description" text="produtos em análise" />
                    gera essa confiança no seu poder de arraste para as
                    <confidence-tag variant="description" text=" lojas selecionadas." />
                  </span>
                  <br />
                  <span v-if="item.confidence === 'LOWER'" class="tooltip-text">
                    Para buscar números mais altos tente ser mais especifico na sua análise, selecionando menos produtos ou menos lojas.
                  </span>
                </div>
              </div>
            </mf-tooltip>
          </template>
        </v-data-table>
      </div>
    </mf-loading>
  </v-card>
</template>

<script>
import { produtosImpulsionadores } from '../../../mixins/produtos-impulsionadores'
import { putEllipsis } from '@/config/helpers.js'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
import ConfidenceTag from '../ConfidenceTag.vue'
export default {
  name: 'BoostStrategy',
  components: {
    ExportEmailReportDialog,
    ConfidenceTag,
  },
  mixins: [produtosImpulsionadores],
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    loading: false,
    loadingTable: false,
    options: {
      page: 1,
      pageSize: 0,
    },
    timeout: {},
    fileFormat: 'CSV',
    confidenceDescription: {
      HIGHER: 'extremamente alta',
      HIGH: 'alta',
      MEDIUM: 'não tão alta',
      LOW: 'baixa',
      LOWER: 'extremamente baixa',
    },
  }),
  computed: {
    filteredProducts() {
      const searchRegex = diacriticSpaceSensitiveRegex(this.search)
      return this.opportunities.boostProducts.filter(
        (boostProduct) => boostProduct.product?.name?.match(searchRegex) || boostProduct.product?.sku === this.search
      )
    },
    isEmpty() {
      return this.products.length
    },
    headers: () => [
      {
        text: 'Produto',
        value: 'product.name',
        width: '70%',
        sortable: false,
      },
      {
        text: 'Confiança',
        value: 'confidence',
        width: '30%',
        sortable: false,
      },
    ],
  },
  watch: {
    search() {
      this.options.page = 1
    },
    products(value) {
      value.length && (this.loading = true)
      this.waitAndGetData()
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    putEllipsis,
    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportProductsAnalysis(emails) {
      try {
        const variables = { emails, fileFormat: this.fileFormat }
        const exportData = await this.exportSalesProductsAnalysis(variables)
        return exportData
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao exportar relatório.', snackbarColor: 'error' })
      }
    },
    generateCampaign() {
      this.$emit('generate-campaign')
    },
    waitAndGetData() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getProducts()
      }, 500)
    },
    openProduct(sku) {
      const url = `/produtos/detalhes-produto/${sku}`
      const routeURL = this.$router.resolve({ path: url }).href

      window.open(routeURL, '_blank')
    },
    onResize() {
      const container = document.querySelector('td.text-start')
      if (!container) this.charCount = 12
      else {
        const width = container.clientWidth
        this.charCount = width / 13
      }
    },
    async getProducts() {
      if (this.filters.units.length < 1 || this.products.length < 1) {
        this.SET_OPPORTUNITIES_KEY({ key: 'boostProducts', payload: [] })
        return
      }
      this.loadingTable = true
      this.options.page = 1
      try {
        const variables = {
          products: this.products.map((product) => product.sku),
          units: this.filters.units,
          pageSize: 0,
        }
        await this.getBoostProducts(variables)
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar produtos impulsionadores.', snackbarColor: 'error' })
      } finally {
        this.loading = false
        this.loadingTable = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.boost-strategy {
  .full-width {
    width: 100%;
  }
  .boost-strategy-title {
    border-bottom: 1px solid $cinza-l70;
    border-radius: 0 !important;

    h2 {
      color: $cinza-d20;
      font-size: 22px;
      line-height: 120%;
      font-weight: 700;
    }
    .rocket-icon {
      width: 36px;
      height: 36px;
      background: rgba(0, 245, 204, 0.15);
      border-radius: 4px;
    }
  }
  .boost-strategy-loader {
    padding: 10% 0 15% 0 !important;
    max-width: 400px;
  }

  .empty-state {
    p {
      color: $cinza-0;
      font-size: 16px;
      font-weight: 400;
      line-height: 120%;
      text-align: center;
    }
  }
  .boost-state {
    .boost-state-header {
      .boost-state-title {
        h2 {
          color: $cinza-d10;
          font-size: 18px;
          line-height: 24px;
          font-weight: 700;
          letter-spacing: 0.02px;
          margin-bottom: 8px;
        }
        span {
          color: $cinza-0;
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
          font-size: 14px;
        }
      }
    }
  }
}
.ellipsis-container {
  position: relative;
}
.ellipsis-td {
  max-width: calc(100%);
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.product-tooltip {
  font-weight: 400;
  line-height: 20px;
  h2 {
    color: $marca-0;
    font-size: 16px;
    letter-spacing: 0.4px;
  }
  .tooltip-text {
    color: $cinza-0;
    font-size: 14px;
  }
  .tooltip-label {
    color: $cinza-d10;
    font-size: 14px;
  }
}
</style>
